<mibi-box-layout x-overflow-handling y-overflow-handling>
    <div class="mibi-profile">
        <mat-card class="mibi-profile-card">
            <mat-card-title class="mibi-profile-card__title">Persönliche Daten</mat-card-title>
            <mat-card-content>
                <dl class="mibi-profile-details">
                    <dt>Vorname:</dt>
                    <dd>{{ currentUser.firstName }}</dd>
                    <dt>Nachname:</dt>
                    <dd>{{ currentUser.lastName }}</dd>
                    <dt>E-Mail:</dt>
                    <dd>{{ currentUser.email }}</dd>
                    <ng-container *ngIf="institution">
                        <dt>Institut:</dt>
                        <dd>{{ institution }}</dd>
                    </ng-container>
                </dl>
            </mat-card-content>
        </mat-card>

        <mat-card class="mibi-profile-card">
            <mat-card-title class="mibi-profile-card__title">
                {{ consentStrings.boxTitle }}
            </mat-card-title>
            <mat-card-content>
                <p class="mibi-consent-intro">{{ consentStrings.introductoryText }}</p>
                <mat-checkbox
                    #consentCheckbox
                    color="primary"
                    class="mibi-consent-checkbox"
                    [checked]="!!currentUser.dataSaveAgreed"
                    (change)="onConsentToggle($event)"
                >
                    {{ consentStrings.consentCheckboxLabel }}
                </mat-checkbox>
            </mat-card-content>
        </mat-card>

        <mibi-email-settings [currentUser]="currentUser"></mibi-email-settings>
    </div>
</mibi-box-layout>
